import React from "react";
import { Trans } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

const TRANS_COMPONENTS = {
  link: <span className={styles.helpLink} />,
  bold: <span className={styles.helpBold} />,
  green: <span className={styles.helpGreen} />,
  orange: <span className={styles.helpOrange} />,
  red: <span className={styles.helpRed} />,
};

function HelpTooltip(props: Props) {
  return (
    <div className={styles.help}>
      <p className={styles.helpIcon}>!</p>
      <div className={styles.helpTooltip}>
        <p className={styles.helpTitle}>
          <Trans i18nKey={props.titleKey} components={TRANS_COMPONENTS} />
        </p>
        <p className={styles.helpBody}>
          <Trans i18nKey={props.bodyKey} components={TRANS_COMPONENTS} />
        </p>
      </div>
    </div>
  );
}

export { HelpTooltip };
